import styled from 'styled-components';
import { HStack, Center } from '@chakra-ui/react';
import { MdWarning } from 'react-icons/md';
import { ProviderConfig } from '@finch-api/common/dist/internal/connect/validate';
import COLORS from 'constants/colors';
import FONTS from 'constants/fonts';

const IncidentBannerContainer = styled.div`
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
  border-radius: 6px;
  font-size: ${FONTS.H5};
  font-weight: 500;
  border: 1px solid ${COLORS.RED.RED_300};
  background-color: ${COLORS.RED.RED_50};
  color: ${COLORS.RED.RED_600};
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 16px;
`;

const MessageWrapper = styled.div`
  line-height: 1.4;
  letter-spacing: 0em;
  text-align: left;
`;

interface IncidentBannerProps {
  provider: ProviderConfig;
}

export const IncidentBanner = ({ provider }: IncidentBannerProps) => {
  // Check if the provider has an active incident
  if (!provider.hasActiveIncident) {
    return null;
  }

  return (
    <IncidentBannerContainer role="alert" aria-live="polite">
      <HStack align="flex-start">
        <Center boxSize="20px">
          <MdWarning
            style={{
              color: COLORS.RED.RED_600,
              fontSize: '20px',
            }}
          />
        </Center>
        <MessageWrapper>
          We&apos;re currently investigating a temporary issue that may affect
          your ability to connect. If you experience an error, please check back
          and try again later.
        </MessageWrapper>
      </HStack>
    </IncidentBannerContainer>
  );
};
